import React from 'react';

import { Box } from '@betterment/samba-react';

import { EmergencyFundHighlights } from './EmergencyFundHighlights';
import { MajorPurchaseHighlights } from './MajorPurchaseHighlights';
import { RetirementGrowthHighlights } from './RetirementGrowthHighlights';

import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';

export const ProjectionHighlights: React.FC<{ purpose: PurposeProjectionQuery['purpose'] }> = ({ purpose }) => {
  const children = (() => {
    switch (purpose.__typename) {
      case 'PurposeMajorPurchase':
        return <MajorPurchaseHighlights purpose={purpose} />;
      case 'PurposeEmergencyFund':
        return <EmergencyFundHighlights purpose={purpose} />;
      case 'PurposeRetirementGrowth':
        return <RetirementGrowthHighlights purpose={purpose} />;
      case 'PurposeRetirementIncome':
        return null;
      default:
        return purpose;
    }
  })();

  if (!children) return null;

  return <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>{children}</Box>;
};
